import React from 'react';

import {
    STATUS_OPEN,
} from './../../store/orders/actions';

import OrderClientInfo from './OrderClientInfo';
import OrderComment from './OrderComment';
import OrderFileList from './OrderFileList';
import OrderFinalPaperList from './OrderFinalPaperList';
import TextWithLink from './../TextWithLink';

const OrderTabInfo = props => {
    const {
        order,
        status,
        onResize,
        fileItems,
        setFilesStickyRef,
        uploadFile,
        removeFile
    } = props;
    const fileList = Object.values(fileItems).filter(file => !file.deleted);
    const taskFiles = fileList.filter(file => file.group === 'task');
    const finalFiles = fileList.filter(file => file.group === 'paper');
    const plagFiles = fileList.filter(file => file.group === 'plagreport');

    return (
        <div>
            <OrderClientInfo order={order} onResize={onResize} />
            {!!order.additional_comment && status !== STATUS_OPEN &&
                <OrderComment icon="additional" title="Additional comment from operator" onResize={onResize}>
                    {order.additional_comment}
                </OrderComment>
            }
            {!!order.comment &&
                <OrderComment icon="comments" title="Comment from operator" onResize={onResize}>
                    {order.comment}
                </OrderComment>
            }
            {!!taskFiles.length &&
                <OrderFileList fileList={taskFiles} onResize={onResize} setStickyRef={setFilesStickyRef} icon="clip" title="Order files" />
            }
            <OrderFinalPaperList
                fileList={finalFiles}
                plagFileList={plagFiles}
                onResize={onResize}
                uploadFile={uploadFile}
                removeFile={removeFile}
                status={status}
                plagreport={order.plagreport}
            />
            <div className="order-tab-detail">
                <TextWithLink text={order.details} />
            </div>
        </div>
    );
};

export default OrderTabInfo;


// WEBPACK FOOTER //
// ./src/components/order/OrderTabInfo.js